module.exports = __webpack_public_path__ + "img/step40_a_remove_tray_and_box.3a0fce39.png";